import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { DatetimeChangeEventDetail, ModalController } from '@ionic/angular';

import { GenericComponent } from '../generic/generic.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-date-picker-modal',
  standalone: false,
  templateUrl: './date-picker-modal.component.html'
})
export class DatePickerModalComponent extends GenericComponent implements OnInit {
  private modalController = inject(ModalController);

  @Input() value = '';
  @Input() input?: HTMLIonInputElement;
  @Input() min?: string;
  @Input() max?: string;

  date = '';

  ngOnInit() {
    this.date = this.value;
  }

  async select() {
    await this.modalController.dismiss({
      date: this.date
    });
  }

  async cancel() {
    await this.modalController.dismiss();
  }

  onDateChange(event: CustomEvent<DatetimeChangeEventDetail>) {
    if (typeof event.detail.value === 'string') {
      this.date = event.detail.value;
    }
  }
}
